/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { PlaybackError } from "./PlaybackError";
export { PlaybackErrorMapper } from "./PlaybackErrorMapper";
export {
  ConnectivityErrorCode,
  GenericErrorCode,
  PlaybackSetupErrorCode,
  RestrictionErrorCode,
  SessionErrorCode
} from "./PlaybackErrorCodes";
export {
  ErrorSurface,
  getBaseErrorCode,
  resolveErrorSurface,
  ROUTED_ERROR_CODES,
  isBlockingMetadataError,
  BLOCKING_METADATA_ERROR_STATES
} from "./ErrorDisplayRouting";
export type { ErrorRoute } from "./ErrorDisplayRouting";
export { SessionFailureClassifier } from "./SessionFailureClassifier";
export { SessionErrorMapper } from "./SessionErrorMapper";
export {
  DEFAULT_WEB_ERROR_CODE,
  PLAYER_ERROR_SEPARATOR,
  getWebErrorCode,
  playerErrorCodes
} from "./PlayerErrorCodes";
export { getWebErrorCodeDescriptions } from "./PlayerErrorMessages";
export type { WebErrorCodeMessage } from "./PlayerErrorMessages";
